import moment from "moment";

const getDueDate = (tray) => {
  const dueDate = tray.min_due_date
    ? moment
        .utc(tray.min_due_date)
        .local()
        .startOf("day")
    : null;
  return dueDate;
};
const getScheduledAt = (tray) => {
  const date = tray.scheduled_at
    ? moment
        .utc(tray.scheduled_at)
        .local()
        .startOf("day")
    : null;
  return date;
};
const formattedDueDate = (tray) => {
  const dueDate = getDueDate(tray);
  return dueDate ? dueDate.format("DD MMM YYYY") : null;
};

const formatDate = (date, format = "DD MMM YYYY") => {
  if (date === "null") return null;
  return date
    ? moment
        .utc(date)
        .local()
        .format(format)
    : null;
};

const toDate = (dateString) => {
  if (!dateString || dateString === "null") return null;
  return moment
    .utc(dateString)
    .local()
    .startOf("day");
};

const lastStateChangeF = (tray) => {
  if (!tray.last_state_change_at) return null;
  return formatDate(tray.last_state_change_at);
};

export { getDueDate, getScheduledAt, formattedDueDate, formatDate, toDate, lastStateChangeF };
